import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography, Stack } from "@mui/material";
import io from 'socket.io-client';
import { styled } from '@mui/material/styles';


const DevTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: 'black',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'black',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'black',
    },
    '&:hover fieldset': {
      borderColor: 'black',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'black',
    },
  },
});

    
function DevModal( { showModal,
    setShowModal,name,setName}
  ) {
  //const [name, setName] = useState("");
  const [comment, setComment] = useState("");
  const [comment_validate, setCommentValidate] = useState(false);
  const [name_validate, setNameValidate] = useState(false);
  let conversation_id = JSON.parse(window.sessionStorage.chat_session).session_id;

  const SendMessage = (payload) => {
    let socket_url = process.env.REACT_APP_SOCKET_URL;

  
    console.log(conversation_id);
    let socket = io(socket_url);

    socket.on('connect', () => {
      console.log("Connected to Socket.io server");
    });



    socket.emit('user_uttered',
      { "session_id": conversation_id, "message": payload }
    );

  }

  const handleClose = () => {
    setShowModal(false);
  };



  const handleSubmit = () => {
    if (name.trim() === "") {
      setNameValidate(true);
      return;
    } 

    if (comment.trim() === "") {
       setCommentValidate(true);
       
      return;
    }
    let commentString = comment.toString();
    let cleanedComment = commentString.replace(/\n/g, "\\n")
    .replace(/\r/g, " \\r ")
    .replace(/\t/g, " \\t ")
    .replace(/"/g, "'");
        
    SendMessage(`/inform{"dev_name":"${name}", "dev_comment":"${cleanedComment}","conv_id":"${conversation_id}"}`);
    console.log("Name:", name, "Comment:", cleanedComment);
    
    setName(name)

    handleClose();
  };


  let conversation = JSON.parse(window.sessionStorage.chat_session).conversation;
// eslint-disable-next-line 
  const extractLatestMessages = (conversation) => { 
    let latestResponse = null; 
    let latestClientResponse = null;// eslint-disable-next-line
   
    
  
    for (let i = conversation.length - 1; i >= 0; i--) {
      const message = conversation[i];
  
      if (message.type === 'component') {
        latestResponse = message.props.attachment.type;
      }
      if (message.type === 'carousel') {
        latestResponse = "advert_carousel";
      }
      if (!latestResponse && message.sender === 'response') {
        latestResponse = message.text;
  

      } else if (!latestClientResponse && message.sender === 'client' && message.text !== 'text') {
        latestClientResponse = message.text;
      }
  
      if (latestResponse && latestClientResponse) {
        break;
      }
    }
  
    return { latestResponse, latestClientResponse  };
  };


  let { latestResponse, latestClientResponse } = extractLatestMessages(conversation);
  return (
    <div>

      <Dialog sx={{ zIndex: 10000000 }} open={showModal} onClose={handleClose} fullWidth maxWidth="sm">
        <Stack spacing={-2} >
        <DialogTitle>report an issue</DialogTitle>
        <DialogTitle>conversation id: {conversation_id}</DialogTitle>
        </Stack>
        <DialogContent>
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <Typography>User: {latestClientResponse}</Typography>
            </Grid>
            <Grid item>
              <Typography>  Bot: {latestResponse}</Typography>
            </Grid>
            <Grid item>
            <DevTextField
              label="Name"
              variant="filled"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              helperText="Slack handle preferred"
              error={name_validate}
            />
          </Grid>
          <Grid item>
            <DevTextField
              label="Comment"
              multiline
              rows={4}
              fullWidth
              variant="filled"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              required
              helperText="Describe the issue"
              error={comment_validate}
            />
          </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button sx={{ color:"black", textTransform:'lowercase',fontSize:'16px',fontFamily:"verdana",lineHeight:"24px", boxShadow:"none", backgroundColor: 'white', border: 1,borderRadius:"8px",borderColor: 'black', "&:hover": { backgroundColor: "#f2f2f2", boxShadow:"none" } }} onClick={handleClose}>Cancel</Button>
          <Button sx={{ textTransform:'lowercase',fontSize:'16px',fontFamily:"verdana",lineHeight:"24px",  boxShadow:"none", backgroundColor: '#ffe923', borderRadius:"8px", "&:hover": { backgroundColor: '#ffe923', boxShadow: "0 0 0 0 transparent !important"} }}  onClick={handleSubmit} color="primary" variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DevModal;